<mat-toolbar>
  <div class="header-container">
    <button
      mat-mini-fab
      (click)="toggleSidenav.emit()"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <!-- Logo o título -->
    <span class="toolbar-title">Unimagen</span>
    <!-- Espaciador para alinear a la derecha
    <span class="spacer"></span> -->
    <!-- Ícono de usuario con menú desplegable -->
    <!-- Nombre del usuario y botón de perfil -->
    <div class="user-info-container">
      <span class="user-name">{{ loggedUser?.preferred_username }}</span>
      <button mat-icon-button [matMenuTriggerFor]="userMenu" color="primary">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="logout()">Cerrar sesión</button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>

